import Api from './BaseRequest'

const Get = () => {
    return Api.Get('/api/notifications')
}

const MarkAsRead = () => {
    return Api.Post('/api/notifications/mark-as-read')
}

export default {
    Get,
    MarkAsRead,
}
